import styled from "styled-components";
import { AllieToolbar } from '../../../components/Toolbar';
import { AllieArrowBackOutlineIcon } from "../../../styling/icons";

export const AllieToolbarStyled = styled(AllieToolbar)`
  --border-color: var(--allie-color-neutral-20);
  --border-width: 0 0 1px;

  > div {
    display: flex;
    align-items: center;
    gap: var(--allie-spacing-md);
  }
`;

export const StyledAllieArrowBackOutlineIcon = styled(AllieArrowBackOutlineIcon)`
  color: var(--allie-color-neutral-40);
  font-size: 24px;
`;
